/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Home from '@mui/icons-material/Home';
import AddIcon from '@mui/icons-material/Add';
import ViewListIcon from '@mui/icons-material/ViewList';
import SettingsIcon from '@mui/icons-material/Settings';

export default [
  {
    title: 'Menu',
    pages: [
      {
        title: 'Home',
        href: '/pm/dashboard',
        icon: Home,
      },
      {
        title: 'Inquéritos',
        href: '/pm/inqueritos',
        icon: ViewListIcon,
      },
      {
        title: 'Configurações',
        href: '#',
        icon: SettingsIcon,
        resource: '',
        children: [
          {
            title: 'Senha Consensus',
            href: '/pm/configuracao-consensus',
          },
        ],
      },
      {
        title: 'Cadastros',
        href: '#',
        icon: AddIcon,
        children: [
          {
            title: 'Cadastro de Inquéritos',
            href: '/pm/cadastro/inquerito',
          },
          // {
          //   title: 'Cadastro de Usuário',
          //   href: '/pm/cadastro/usuario',
          // }
        ],
      },
      {
        title: 'Sair',
        href: '/',
        icon: ExitToAppIcon,
      },
    ],
  },
];
